import React from 'react'
import { Field } from '../Field'

export const Empty = () => (
  <Field className='empty' />
)
